import { FunctionComponent } from 'react'
import { useActor } from '@xstate/react'
import { DonationInterpreter } from '../src/machines/donationMachine'

type Props = {
  service: DonationInterpreter
  className?: string
}

export const CustomDonationInput: FunctionComponent<Props> = (props) => {
  const { service, className } = props
  const [{ context }, send] = useActor(service)
  const { customDonation } = context

  const setCustomDonation = (value: string) =>
    send({ type: 'SET_CUSTOM', value })
  const saveCustomDonation = () => send({ type: 'SAVE_CUSTOM' })

  return (
    <input
      className={className}
      id="customDonation"
      value={customDonation && customDonation !== '0' ? customDonation : ''}
      type="number"
      min="0"
      step="1"
      onInput={(ev) => {
        setCustomDonation(ev.currentTarget.value)
        saveCustomDonation()
      }}
    />
  )
}
